// Service Categories (India-specific)
export const SERVICE_CATEGORIES = [
  'Crisis / Suicide Prevention Helplines',
  'Free Counselling Services',
  'Low-Cost Therapy',
  'Psychiatrists',
  'Psychologists / Therapists',
  'Government Mental Health Services',
  'De-addiction & Substance Use Support',
  'Rehabilitation & Treatment Centres',
  'Support Groups',
  'Domestic Violence & Abuse Support',
  'LGBTQIA+ Support Services',
  'Youth / Student Mental Health',
  'Women-only Services',
  'Emergency / Hospital-based Services',
];

// Specialties
export const SPECIALTIES = [
  'Depression',
  'Anxiety',
  'PTSD',
  'Addiction',
  'Bipolar Disorder',
  'OCD',
  'Eating Disorders',
  'Sleep Disorders',
  'Grief & Loss',
  'Trauma',
  'Self-harm',
  'Relationship Issues',
  'Family Therapy',
  'Child Psychology',
];

// Languages
export const LANGUAGES = [
  'Hindi',
  'English',
  'Bengali',
  'Telugu',
  'Marathi',
  'Tamil',
  'Gujarati',
  'Urdu',
  'Kannada',
  'Malayalam',
  'Punjabi',
  'Odia',
];

// Age Groups
export const AGE_GROUPS = [
  'Children (0-12)',
  'Adolescents (13-17)',
  'Adults (18-64)',
  'Elderly (65+)',
];

// Target Populations
export const TARGET_POPULATIONS = [
  'Women',
  'LGBTQIA+',
  'Students',
  'Migrants',
  'Veterans',
  'Survivors of Abuse',
  'Low-income',
];

// Treatment Approaches
export const TREATMENT_APPROACHES = [
  'Cognitive Behavioral Therapy (CBT)',
  'Psychotherapy',
  'Medication',
  'Peer Support',
  'Rehabilitation',
  'Family Therapy',
  'Group Therapy',
  'Art Therapy',
  'Music Therapy',
];

// Indian States
export const INDIAN_STATES = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Delhi',
  'Jammu & Kashmir',
  'Ladakh',
];

// Cost Options
export const COST_OPTIONS = ['free', 'low-cost', 'paid'];

// Mode Options
export const MODE_OPTIONS = ['online', 'in-person'];

// Service Status
export const SERVICE_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};
